import { Button } from '@eureca/ui';
import { ConsultantsMenu } from '@/shared/consultants-menu/ConsultantsMenu';
import { TriangleAlertIcon } from './icons';

export interface NoAccessFallbackProps {
  onContactSupport: () => void;
  onLogout: () => void;
}

/**
 * Rendered when the BFF returns 403 — the consultor authenticated, but their
 * Keycloak roles do not grant access to the recruiter app. Distinct from the
 * empty-state (which is reached after a successful 200 with zero companies).
 */
export function NoAccessFallback({ onContactSupport, onLogout }: NoAccessFallbackProps) {
  return (
    <div className="flex min-h-dvh flex-row bg-muted">
      <ConsultantsMenu onLogout={onLogout} />

      <main className="flex flex-1 flex-col items-center justify-center px-8 py-16">
        <div className="flex w-full max-w-md flex-col items-center gap-5 text-center">
          <div
            aria-hidden="true"
            className="flex h-16 w-16 items-center justify-center rounded-full bg-muted"
          >
            <TriangleAlertIcon className="h-6 w-6 text-foreground" />
          </div>
          <div className="flex flex-col items-center gap-2">
            <h2 className="text-2xl font-semibold leading-none tracking-tight text-foreground">
              Acesso não autorizado
            </h2>
            <p className="text-base leading-normal text-muted-foreground">
              Sua conta não tem permissão para acessar o app de consultores. Se achar que isso pode
              ser um erro, fale com o nosso suporte.
            </p>
          </div>
          <div className="mt-2 flex flex-col items-center gap-2">
            <Button
              type="button"
              size="lg"
              onClick={onContactSupport}
              data-testid="recruiter-home-no-access-cta"
            >
              Falar com suporte
            </Button>
          </div>
        </div>
      </main>
    </div>
  );
}
